import { __decorate, __metadata } from "tslib";
import { Injectable } from 'angular-ts-decorators';
var SectionTogglerService = (function () {
    function SectionTogglerService($rootScope) {
        this.$rootScope = $rootScope;
    }
    SectionTogglerService.prototype.toggleSection = function (sectionName, collapsed) {
        this.$rootScope.$broadcast('sectionToggler:toggle', { sectionName: sectionName, collapsed: collapsed });
    };
    SectionTogglerService.$inject = ['$rootScope'];
    SectionTogglerService = __decorate([
        Injectable('sectionTogglerService'),
        __metadata("design:paramtypes", [Object])
    ], SectionTogglerService);
    return SectionTogglerService;
}());
export { SectionTogglerService };
